import { Injectable } from '@angular/core';

import {DimensionLevelService} from './dimension-level.service';
import {Dimension, DimensionItem, DimensionLevel, Perspective} from '@selpia/shared/models';

@Injectable()
export class CheckNextDimensionLevelService extends DimensionLevelService {
  getDimensionLevel(dimensionItem: DimensionItem, perspective: Perspective | undefined): DimensionLevel | undefined {
    const dimension = dimensionItem.dimension;
    const dimensionLevel = dimensionItem.dimensionLevel;
    const perspectiveDimensionLevel = perspective?.focusDimensionLevel;
    const sameDimensionAsPerspective =
      !!perspectiveDimensionLevel && dimension.levels.includes(perspectiveDimensionLevel);
    let newPerspectiveDimensionLevel: DimensionLevel | undefined = perspectiveDimensionLevel;
    if ((!newPerspectiveDimensionLevel || sameDimensionAsPerspective) && dimensionLevel) {
      newPerspectiveDimensionLevel = this.#getNextDimensionLevel(dimension, dimensionLevel);
    }

    console.log('CheckNextDimensionLevelService', sameDimensionAsPerspective, newPerspectiveDimensionLevel);

    return newPerspectiveDimensionLevel;
  }

  #getNextDimensionLevel(dimension: Dimension, dimensionLevel: DimensionLevel): DimensionLevel | undefined {
    const nextLevelNumber = dimensionLevel.levelNumber + 1;
    const newLevel = dimension.levels.find(l => l.levelNumber === nextLevelNumber);
    return newLevel || dimension.levels.at(-1);
  }
}
